import Marquee from "react-fast-marquee";
import { RIBBON } from "./data";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";

export const Ribbon = () => {
  const { settings } = useContent();
  const tx = useTx();
  const words = settings.ribbon && settings.ribbon.length ? settings.ribbon : RIBBON;
  const style = txtStyle(tx("ribbon.word"));
  return (
    <section className="py-6 bg-cantina-blue overflow-hidden" data-testid="ribbon-section">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="font-script text-cantina-cream px-8" style={style}>{word}</span>
            <span className="text-cantina-marigold text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
